export default __webpack_public_path__ + "static/media/11_5.062d6092.png";